import { ActiveJob } from '@assets/component/ActiveJob/ActiveJob';
import { BacktestingDashboard } from '@assets/component/AdminSection/BacktestingDashboard';
import { Logo } from '@assets/component/Header/Logo';
import { Loading } from '@assets/component/Loading/Loading';
import { FloatingSelectionPanel } from '@assets/component/RefDataSelection/FloatingSelectionPanel';
import { Flex } from '@assets/component/UI/Flex/Flex';
import {
    useClientSettingStore,
    useStore,
    useStoreUI
} from '@assets/model/Store';
import { useSelectionStore } from '@assets/model/StoreSelection';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import {
    Route,
    BrowserRouter as Router,
    Routes,
    useNavigate
} from 'react-router-dom';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { ToastContainer } from 'react-toastify';
import DealDBPage from './DealDBPage';
import DealView from './DealView';
import LoginPage from './Login';
import ModalContainer from '@assets/component/ModalContainer/ModalContainer';
import { DealFlowiseProfile } from './DealFlowiseProfile';

const maintenancePage = (
    <Flex
        style={{ backgroundColor: 'white' }}
        fillCell={true}
        direction="column"
        justify="center"
        alignItems="center"
    >
        <div style={{ transform: 'scale(2)' }}>
            <Flex direction="column" justify="center" alignItems="center">
                <Logo />
                <div style={{ fontSize: '20px', marginTop: '15px' }}>
                    We are currently upgrading!
                </div>
            </Flex>
        </div>
    </Flex>
);

const NavigationSetup = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Set up navigation callback for Firebase adapter
        getFirebase().setNavigationCallback((path: string) => {
            // Re-enable loading when navigating to main pages
            if (path === '/') {
                const uiStore = useStoreUI();

                // Force loading state for visual transition
                uiStore.disableLoading = false;
                uiStore.forceLoading = true;

                // Clear force loading after transition
                setTimeout(() => {
                    uiStore.forceLoading = false;
                }, 2000); // Show loading for 2 seconds
            }
            navigate(path);
        });
    }, [navigate]);

    return null;
};

export const PageFrame = observer(() => {
    const store = useStore();
    const selectionStore = useSelectionStore();
    const clientSettings = useClientSettingStore();

    useEffect(() => {
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                const storeUI = useStoreUI();
                storeUI.onKeyUpReset();
            }
        });

        document.addEventListener('keydown', e => {
            const storeUI = useStoreUI();

            //key for back?
            // if (e.key === 'Backspace') {
            //     if (
            //         (e.currentTarget as any).activeElement.localName ==
            //             'input' ||
            //         (e.currentTarget as any).activeElement.localName ==
            //             'textarea'
            //     ) {
            //         return;
            //     }
            //     window.history.back();
            // }

            if (e.ctrlKey && e.key.toLowerCase() === 'q') {
                const store = useStore();
                store.showAdminConsoleFromKeyboardShortcut =
                    !store.showAdminConsoleFromKeyboardShortcut;
            }

            if (e.ctrlKey) {
                storeUI.isKeyControlKeyDown = true;
            }

            if (e.key === 'PageUp') {
                storeUI.scrolling = 'UP';
            } else if (e.key === 'PageDown') {
                storeUI.scrolling = 'DOWN';
            } else {
                storeUI.scrolling = 'NONE';
            }

            if (e.key == 'Tab') {
                if (
                    (e.currentTarget as any).activeElement.localName ==
                        'input' ||
                    (e.currentTarget as any).activeElement.localName ==
                        'textarea'
                ) {
                    return;
                }
                e.preventDefault();
                storeUI.isKeyShiftKeyDown = e.shiftKey;
                storeUI.isKeyTabDown = true;
            }

            if (e.key == 'Escape') {
                e.preventDefault();
                storeUI.isKeyEscapeDown = true;
            }
        });

        document.addEventListener('keyup', e => {
            const storeUI = useStoreUI();
            storeUI.onKeyUpReset();
        });
    }, []);

    if (clientSettings.isMaintenanceOn && !store.isAdmin) {
        return maintenancePage;
    }

    const hrefContainsLogin = window.location.href.includes('/login');
    return (
        <>
            {clientSettings.isMaintenanceOn && (
                <div
                    style={{
                        color: 'white',
                        fontSize: '20px',
                        position: 'absolute',
                        backgroundColor: 'red',
                        zIndex: 100000000
                    }}
                >
                    MAINTENANCE MODE IS ENABLED
                </div>
            )}
            <ToastContainer
                position="bottom-left"
                style={{
                    zIndex: 100000000,
                    textAlign: 'left'
                }}
            />
            <ActiveJob />

            <Loading />
            <ModalContainer />
            <Router>
                <NavigationSetup />
                <Routes>
                    <Route
                        path="/profile_debug"
                        element={
                            store.isLoaded && !useStoreUI().forceLoading ? (
                                <DealFlowiseProfile />
                            ) : null
                        }
                    />
                    <Route
                        path="/"
                        element={
                            store.isLoaded && !useStoreUI().forceLoading ? (
                                <DealDBPage />
                            ) : null
                        }
                    />
                    {/* <Route path="/chat" element={<ChatUI />} /> */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        path="/:id"
                        element={
                            store.isLoaded && !useStoreUI().forceLoading ? (
                                <DealView />
                            ) : null
                        }
                    />

                    {/* Backtesting Route (admin only) */}
                    <Route
                        path="/admin/backtesting"
                        element={
                            store.isLoaded &&
                            !useStoreUI().forceLoading &&
                            store.isAdmin ? (
                                <BacktestingDashboard />
                            ) : null
                        }
                    />
                </Routes>
            </Router>

            {/* Render floating panel directly based on MobX state */}
            {selectionStore.isSelectionModeActive && <FloatingSelectionPanel />}
        </>
    );
});
